import axios from 'axios'
import LGSdk from './index'

/**
 * 获取多语言标识配置
 * @returns
 */
export const getLGConfigs = () => {
  const timestamp = new Date().getTime()
  return axios.get(`${LGSdk.LGAliOssBaseURL}${LGSdk.LGOssPathEnum.LG_CONFIG}${LGSdk.LGFileNameEnum.LG_CONFIG}?t=${timestamp}`)
}

/**
 * 获取平台多语言文本配置
 * @returns
 */
export const getLGLabelsByPlatform = (platform) => {
  const timestamp = new Date().getTime()
  const path = LGSdk.LGOssPathEnum[platform]
  return axios.get(`${LGSdk.LGAliOssBaseURL}${path}${LGSdk.LGFileNameEnum.LG_LABEL}?t=${timestamp}`)
}
